import { render, staticRenderFns } from "./ScreenConfigureBoard.vue?vue&type=template&id=58babe9d&scoped=true&"
import script from "./ScreenConfigureBoard.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigureBoard.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConfigureBoard.vue?vue&type=style&index=0&id=58babe9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58babe9d",
  null
  
)

export default component.exports